import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createMultiplesActividadesAplicacionService,
  getActividadAplicacionByIdService,
  getActividadesAplicacionService,
  toggleActividadAplicacionActiveService,
  updateActividadAplicacionService,
} from "../../../services/actividadesAplicacion/actividadesAplicacion.service";

export const getActividadesAplicacionThunk = createAsyncThunk(
  "actividadesAplicacion/getAll",
  async ({ page = 1, search = "", talento = "" } = {}, { rejectWithValue }) => {
    try {
      return await getActividadesAplicacionService(page, search, talento);
    } catch (error) {
      if (error.response?.status === 404)
        return rejectWithValue("Página no válida");
      return rejectWithValue(
        error.response?.data?.detail ||
          error.response?.data?.message ||
          "Error al obtener actividades",
      );
    }
  },
);

export const getActividadAplicacionByIdThunk = createAsyncThunk(
  "actividadesAplicacion/getById",
  async (id, { rejectWithValue }) => {
    try {
      return await getActividadAplicacionByIdService(id);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail ||
          error.response?.data?.message ||
          "Error al obtener actividad",
      );
    }
  },
);

export const updateActividadAplicacionThunk = createAsyncThunk(
  "actividadesAplicacion/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      return await updateActividadAplicacionService(id, payload);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail ||
          error.response?.data?.message ||
          "Error al actualizar actividad",
      );
    }
  },
);

export const toggleActividadAplicacionActiveThunk = createAsyncThunk(
  "actividadesAplicacion/toggleActive",
  async (id, { rejectWithValue }) => {
    try {
      return await toggleActividadAplicacionActiveService(id);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail ||
          error.response?.data?.message ||
          "Error al cambiar estado",
      );
    }
  },
);

export const createMultiplesActividadesAplicacionThunk = createAsyncThunk(
  "actividadesAplicacion/createMultiples",
  async (payload, { rejectWithValue }) => {
    try {
      return await createMultiplesActividadesAplicacionService(payload);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail ||
          error.response?.data?.message ||
          "Error al crear actividades",
      );
    }
  },
);
